<template lang="pug">
.settings
	submenu
		settings-submenu
	.content
		transition(name='page' mode='out-in')
			keep-alive
				router-view
</template>

<script>
import SettingsSubmenu from "./includes/SettingsSubmenu";

export default {
	components: {
		SettingsSubmenu
	}
};
</script>
